import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import LeadPipelineStageForm, { type LeadPipelineStageFormFieldValues } from './LeadPipelineStageForm';
import type { LeadPipelineStageDetail, LeadPipelineStageFormValues } from '../types';

export interface LeadPipelineStageFormDrawerProps {
  open: boolean;
  onClose: () => void;
  mode: 'add' | 'edit';
  stage: LeadPipelineStageDetail | null | undefined;
  loadingStage: boolean;
  onSave: (values: LeadPipelineStageFormValues) => void;
  saving: boolean;
}

const LeadPipelineStageFormDrawer: React.FC<LeadPipelineStageFormDrawerProps> = ({
  open,
  onClose,
  mode,
  stage,
  loadingStage,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<LeadPipelineStageFormFieldValues>();

  useEffect(() => {
    if (!open) return;
    if (mode === 'add') {
      form.resetFields();
      form.setFieldsValue({ isActive: true, sortOrder: 0, category: 1 });
    }
  }, [open, mode, form]);

  const title = mode === 'add' ? 'Add pipeline stage' : 'Edit pipeline stage';

  return (
    <Drawer
      title={title}
      destroyOnClose
      size="large"
      placement="right"
      open={open}
      onClose={onClose}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      {(mode === 'add' || !loadingStage) && (
        <LeadPipelineStageForm
          form={form}
          mode={mode}
          initialValues={mode === 'edit' ? stage ?? null : null}
          onFinish={onSave}
        />
      )}
    </Drawer>
  );
};

export default LeadPipelineStageFormDrawer;
